var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('button',{staticClass:"toggle-button",style:(_vm.toggleButtonStyles),on:{"click":_vm.toggleCollapsible}},[_vm._v(_vm._s(_vm.toggleText))]),(!_vm.isCollapsed)?_c('div',{staticClass:"collapsible",style:(_vm.collapsibleStyles)},[_vm._t("content")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }